import React, { useState } from 'react';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import * as S from './index.styled';

interface ConsentAgreementProps {
  agreements: Record<string, boolean>;
  onAgreementChange: (id: string, checked: boolean) => void;
}

const ConsentAgreement: React.FC<ConsentAgreementProps> = ({ agreements, onAgreementChange }) => {

  const [serviceAgreement] = useState(`“SK텔레콤 리워드 적립 문자” 서비스 이용 약관

제 1 장 총 칙
제 1조 (목적)
본 약관은 SK텔레콤 주식회사(이하 “회사”라 합니다)가 제공하는 “SK텔레콤 리워드 적립 문자 서비스”(이하 “서비스”)를 이용함에 있어 필요한 “서비스” 이용조건 및 절차 등 기타 제반 사항을 규정함을 목적으로 합니다.

제 2조 (약관의 효력 및 변경)
①	본 약관은 “서비스”를 이용하고자 하는 모든 회원에 대하여 그 효력을 발생합니다.
②	본 약관의 내용은 “서비스” 화면에 게시하거나 기타의 방법으로 회원에게 공지하고, 이에 동의한 회원이 “서비스”에 가입함으로써 효력이 발생합니다.
③	“회사”는 필요하다고 인정되는 경우 본 약관을 변경할 수 있으며, “회사”가 약관을 변경할 경우에는 적용일자 및 변경 사유를 명시하여 제2항과 같은 방법으로 그 적용일자 15일전에 공지합니다. 다만, 회원에게 불리하거나 회원의 권리 또는 의무에 관한 중요 사항에 대한 약관 변경인 경우에는 그 적용일자 30일전에 공지하며, E-Mail, SMS 등으로 회원에게 개별 통지합니다. 단, 회원의 연락처 미기재, 변경 후 미수정 등으로 인하여 “회사”의 귀책사유 없이 개별 통지가 어려운 경우에 한하여 본 항의 공지를 함으로써 개별 통지한 것으로 간주합니다.
④	“회사”가 회원에게 제3항에 따라 개정 약관을 공지 또는 통지하면서 약관 개정 적용일까지 거부의사를 표시하지 아니할 경우 약관의 변경에 동의한 것으로 간주한다는 내용을 알렸음에도 회원이 명시적으로 거부의사를 표시하지 아니하면 회원이 개정 약관에 동의한 것으로 간주합니다.
⑤	회원은 변경된 “서비스” 또는 약관 사항에 동의하지 않는 경우 “서비스” 이용 계약의 해지를 요청할 수 있습니다. 다만, “회사”가 개정 약관에 동의하지 않은 회원에게 기존 약관을 적용할 수 없는 사정이 있는 경우에는 “회사”는 해당 회원과의 이용 계약을 해지할 수 있습니다.

제 3조 (약관 외 규정)
본 약관에 명시되지 않은 사항에 대해서는 관련 법령 및 “회사”가 정한 “서비스”의 세부이용지침 등의 규정에 의합니다.

제 4조 (용어의 정의)
①	본 약관에서 사용하는 용어의 정의는 다음 각 호와 같습니다.
1.	“SK텔레콤 리워드 적립 문자 서비스”(이하 “서비스”)는 “회사”가 “회사”의 광고 수신 동의 고객을 대상으로 발송한 문자메시지를 통해 접속한 모바일 웹상의 특정 광고 캠페인에 참여함으로써 보상을 획득하는 광고 플랫폼 서비스를 말합니다.
2.	“광고 대행사”(이하 “대행사”)란 광고주를 대신하여 광고주의 광고를 기획, 제작하고 “서비스”에 광고 게재 및 집행을 요청하는 업체로서 광고주로부터 광고주의 책임과 권한을 포괄적으로 위임 받은 업체를 말합니다.
3.	“회원”은 사이트에 접속하여 본 약관에 동의하고, ID(고유번호)와 Password(비밀번호)를 발급 받은 광고주와 “대행사”를 말하며, 회원의 자격 및 권한 등은 본 약관에서 정한 바에 따라 일부 제한 될 수 있습니다.
4.	“사이트”란 “서비스”를 위하여 “회사”가 운영하는 웹사이트(https://admin.wereward.kr/)를 의미합니다.
5.	“ID(고유번호)”란 회원 식별과 회원의 “서비스” 이용을 위하여 회원이 선정하고 “회사”가 승인하는 영문자와 숫자의 조합을 의미하며, 하나의 연계정보(CI) & 중복확인정보(DI)에 하나의 ID만 발급, 이용 가능합니다.
6.	“Password(비밀번호)”란 회원의 정보 보호를 위해 회원 자신이 설정한 문자와 숫자의 조합을 말합니다. 
7.	“운영자”란 “서비스”의 전반적인 관리와 원활한 운영을 위하여 “회사”가 선정한 자를 말합니다.

②	제1항에서 정의된 내용 외의 용어는 관련 법령, 상관례 및 “서비스” 안내 등에서 정하는 바에 의합니다.

제 2 장 “서비스” 이용
제 5조 (계약의 성립)
①	“회사”와 회원간의 이용계약은 “서비스”의 이용을 원하는 고객(이하 “이용신청 고객“이라 함)이 “위의 이용약관에 동의하십니까?” 라는 이용 신청 시의 물음에 이용신청 고객이 "동의" 버튼을 누르면 약관에 동의하는 것으로 간주됩니다.
②	이용 계약은 고객의 이용신청에 대해 “회사”가 승낙함으로써 성립합니다.
제 6조 (이용 신청)
①	이용신청고객은 “회사”가 제시하는 소정 양식의 이용신청서를 “회사”에 제출하거나 사이트에 “회사”가 지정하는 방법으로 “서비스” 이용신청을 하여야 한다.
②	이용신청고객은 이용자 본인의 실명 또는 법인명, 상호명으로 이용신청을 하여야 하며, “회사”는 본 약관을 이용신청고객에게 고지하고, 이용신청고객의 동의를 받아 가입 처리를 한다. “서비스”의 이용자 등록 화면에서 이용신청고객이 가입신청 양식에 항목은 다음과 같다.
-	ID(고유번호)
-	Password(비밀번호)
-	이름
-	부서명
-	E-mail(전자우편) 주소
-	이동전화번호
-	회사 정보
 - 상호명(사업자 등록증에 기재된 회사명)
 -	대표자명
 -	업태 및 업종
 -	주소
 -	사업자등록번호
 -	사업자 등록증(파일 첨부)
-	기타 “회사”가 필요하다고 인정하는 사항

제 7조 (이용신청의 승낙)
“회사”는 제 6조에서 정한 사항을 정확히 기재하여 이용 신청한 고객에 대하여 “서비스” 이용 신청을 승낙하며, “회사”가 이용신청을 승낙함과 동시에 이용신청고객은 회원자격을 부여 받습니다.

제 8조 (이용신청 승낙의 제한)
①	“회사”는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않을 수 있습니다.
1.	비실명 또는 타인의 동의없이 타인의 명의를 사용하여 신청한 경우
2.	이용신청고객 정보를 허위로 기재한 경우
3.	사회의 안녕질서 또는 미풍양속을 저해하거나, 저해할 목적으로 신청한 경우
4.	기타 이용신청고객의 귀책사유로 “회사”가 정한 조건에 미달하는 경우

②	“회사”는 다음 각 호에 해당하는 경우 이용신청에 대한 승낙을 유보할 수 있습니다.
1.	천재지변으로 인한 설비의 장애 상태가 발생한 경우
2.	“서비스”를 제공함에 따라 “회사”의 전체 “서비스” 품질 유지에 곤란하다고 판단되는 경우
3.	이용신청고객이 “서비스” 이용료를 체납한 사실이 있는 경우
4.	“서비스”를 제공하기 위한 설비의 여유가 없거나 기술상 “서비스” 제공이 곤란한 경우
5.	“회사”의 운영상, 사업상 위해 요소 또는 위해 우려가 있는 경우
6.	회원의 “서비스” 해지 또는 변경 당일에 “서비스” 이용을 재신청 또는 변경신청 하는 경우
7.	기타 “회사”가 정당한 사유로 이용 승낙하는 것이 곤란한 경우

③	“회사”는 이용신청절차 완료 후 제1항의 각 호에 따른 사유가 발견된 경우 이용 승낙을 철회할 수 있습니다.
④	“회사”는 제1항 내지 제3항에 의해 이용 승낙이 거절, 유보, 철회된 경우 이를 즉시 이용신청고객이 기재한 연락처로 통지하여야 합니다. 이용신청고객의 부정확한 기재사항으로 인한 연락처의 불명 때문에 통지하지 못하였을 경우 “회사”는 그에 대한 책임이 없습니다.

제 9조 (기재 사항의 수정)
회원은 이용 신청 시 기재한 사항이 변경되었을 경우 “회사”가 정한 별도의 이용 방법으로 정해진 양식 및 방법에 의하여 수정하여야 합니다. “회사”는 회원이 변경 사항을 적시에 수정하지 않음으로 인하여 발생하는 문제에 대해서는 귀책사유가 없는 한 책임을 지지 않습니다.

제 3장 “서비스” 이용
제 10조 (“서비스”의 이용개시)
①	“회사”는 회원의 이용 신청을 승낙한 때부터 “서비스”를 개시합니다. 단, 일부 “서비스”의 경우에는 지정된 일자부터 “서비스”를 개시합니다.
②	“회사”의 업무상 또는 기술상의 장애로 인하여 “서비스”를 개시하지 못하는 경우에는 사이트에 공시하거나 회원에게 이를 통지합니다. 다만, 불가피한 사정에 의한 경우에는 사후 공지할 수 있습니다.
제 11조 (“서비스”의 이용시간)
①	“서비스”의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 다만, “회사”의 업무상이나 기술상의 이유로 “서비스”가 일지 중지될 수 있고, 또한 운영 상의 목적으로 “회사”가 정한 기간에는 “서비스”가 일시 중지될 수 있습니다. 이러한 경우 “회사”는 사전에 이를 공지하며, 부득이한 경우 사후 공지할 수 있습니다.
②	“회사”는 “서비스”를 일정범위로 분할하여 각 범위 별로 이용 가능한 시간을 별도로 정할 수 있으며 이 경우 그 내용을 공지합니다.
제 12조 (“서비스” 변경 및 중지)
①	“회사”는 변경될 “서비스”의 내용 및 제공일자를 제20조 제2항에서 정한 방법으로 회원에게 통지하고 “서비스”를 변경하여 제공할 수 있습니다.
②	“회사”는 다음 각 호에 해당하는 경우 “서비스”의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
1.	“서비스”용 설비의 보수 등 공사로 인한 부득이한 경우
2.	회원이 “회사”의 영업활동을 방해하는 경우
3.	정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 “서비스” 제공에 지장이 있는 경우
4.	“서비스” 제공을 위하여 “회사”가 제3자와 체결한 계약의 종료 등 “회사”의 제반 사정으로 “서비스”를 유지할 수 없는 경우
5.	기타 천재지변, 국가비상사태 등의 불가항력적 사유가 있는 경우
③	제2항에 의한 “서비스” 제한•중지의 경우 “회사”는 제20조에서 정한 방법으로 회원에게 통지합니다. 다만, “회사”가 통제할 수 없는 사유로 인한 “서비스”의 중단(운영자에게 고의, 과실 없는 디스크 장애, 시스템 다운 등)으로 인하여 사전통지가 불가능한 경우에는 그러하지 아니합니다.
④	“회사”는 “서비스”의 변경, 제한이나 중지로 발생하는 문제에 대해서는 책임을 지지 않습니다.
제 13조 (문자 전송에 대한 회원의 의무와 책임)
①	회원은 “서비스”를 통해 문자를 전송할 수 있습니다. 단, 회원의 자격에 따라 제한될 수 있습니다.
②	회원이 문자를 전송함으로써 유료 사용액이 발생할 경우, “회사”는 해당 요금을 청구합니다.
③	회원은 본 조의 문자를 이용하여 수신자의 의사에 반하는 광고성 정보를 일시에 다량으로 또는 지속적으로 전송하거나 (불법)스팸을 전송해서는 안됩니다.
제 14조 (정보의 제공 및 광고의 게재)
①	“회사”는 “서비스”를 운영함에 있어 “회사”의 “서비스” 관련 각종 정보 및 광고를 “서비스” 화면에 게재하거나 E-Mail및 SMS 등의 방법으로 회원에게 제공할 수 있습니다.
②	“대행사”가 “서비스”상에 게재되어 있는 광고를 이용하거나 “서비스”를 통한 광고주의 판촉활동에 참여하는 등의 방법으로 교신 또는 거래를 하는 것은 전적으로 “대행사”와
광고주간의 문제입니다. 만약 “대행사”와 광고주간에 문제가 발생할 경우에는 “대행사”와 광고주가 직접 해결하여야 하며, 이와 관련하여 “회사”는 책임을 지지 않습니다.
제 15조 (게시물 또는 내용물의 삭제)
①	“회사”는 회원이 게시하거나 전달하는 “서비스” 내의 모든 내용물(회원간 전달 포함)이 다음 각 호의 경우에 해당한다고 판단되는 경우 사전통지 없이 내용물을 삭제할 수 있으며, 이에 대해 “회사”는 책임을 지지 않습니다.
1.	“회사”, 다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우
2.	공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등의 유포에 해당하는 경우
3.	범죄적 행위에 결부된다고 객관적으로 인정되는 내용인 경우
4.	“회사” 또는 제3자의 저작권 또는 기타 권리를 침해하는 내용인 경우
5.	제2항 소정의 세부이용지침을 통하여 “회사”에서 규정한 게시기간을 초과한 경우
6.	“회사”에서 제공하는 “서비스”와 관련 없는 내용인 경우
7.	불필요하거나 승인되지 않은 광고, 판촉물인 경우
8.	기타 관계 법령 및 “회사”의 지침 등에 위반된다고 판단되는 경우
②	“회사”는 게시물에 관련된 세부이용지침을 별도로 정하여 시행할 수 있으며, 회원은 그 지침에 따라 각종 게시물(회원간 전달 포함)을 등록하거나 삭제하여야 합니다.
제 16조 (게시물의 저작권)
①	회원이 “서비스” 내에 게시한 게시물(회원간 전달 포함)의 저작권은 회원이 소유하며 “회사”는 “서비스” 내에 이를 게시할 수 있는 권리를 갖습니다.
②	“회사”는 게시한 회원의 동의 없이 게시물을 다른 목적으로 사용할 수 없습니다.
③	“회사”는 회원이 “서비스” 내에 게시한 게시물이 타인의 저작권 등 권리를 침해하더라도 이에 대한 민, 형사상의 책임을 부담하지 않습니다. 만일 회원이 타인의 저작권 등 권리를 침해하였음을 이유로 “회사”가 타인으로부터 손해배상청구 등 이의제기를 받은 경우 회원은 “회사”의 면책을 위하여 노력하여야 하며, “회사”가 면책되지 못한 경우 회원은 그로 인해 “회사”에 발생한 모든 손해를 부담하여야 합니다.
④	“회사”는 회원이 “서비스”를 해지하거나 적법한 사유로 “서비스”가 해지된 경우 해당 회원이 게시하였던 게시물을 삭제할 수 있습니다.
⑤	“회사”가 작성한 저작물에 대한 저작권은 “회사”에 귀속됩니다.
⑥	회원은 “서비스”를 이용하여 얻은 정보를 가공, 판매하는 행위 등 “서비스”에 게재된 자료를 영리 목적으로 이용하거나 제3자에게 이용하게 할 수 없으며, 게시물에 대한 저작권 침해는 관계 법령의 적용을 받습니다.
제 4 장 계약당사자의 의무
제 17조 (“회사”의 의무)
①	“회사”는 “서비스”와 관련한 회원의 불만사항이 접수되는 경우 이를 신속하게 처리하여야 하며, 신속한 처리가 곤란한 경우 그 사유와 처리 일정을 “서비스” 화면에 게재하거나 SMS, 이메일 등을 통하여 동 회원에게 통지합니다.
②	“회사”가 제공하는 “서비스”로 인하여 회원에게 손해가 발생한 경우 그러한 손해가 “회사”의 고의나 과실에 의해 발생한 경우에 한하여 “회사”에서 책임을 부담하며, 그 책임의 범위는 통상손해에 한합니다.
③	“회사”는 정보통신망 이용촉진 및 정보보호에 관한 법률, 개인정보 보호법, 통신비밀보호법, 전기통신사업법 등 “서비스”의 운영, 유지와 관련 있는 법규를 준수합니다.
제 18조 (회원의 의무)
①	회원은 “서비스”를 이용할 때 다음 각 호의 행위를 하여서는 아니 됩니다.
1.	타인의 이용ID 및 비밀번호 도용 등을 통해 부정하게 “서비스”에 접속하여 사용하는 행위
2.	“회사”의 “서비스” 정보를 이용하여 얻은 정보를 “회사”의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위
3.	타인의 명예를 손상시키거나 불이익을 주는 행위
4.	“회사”의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 행위
5.	공공질서 및 미풍양속에 위반되는 내용 등을 타인에게 유포하는 행위
6.	“서비스” 운영을 고의로 방해하거나 “서비스”의 안정적 운영을 방해할 수 있는 정보 및 수신자의 명시적인 수신거부의사에 반하여 광고성 정보를 전송하는 행위
7.	“서비스”에 게시된 정보를 변경하는 행위
8.	관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 포함)의 전송 또는 게시 행위
9.	“회사”의 직원이나 “서비스” 운영자를 가장하거나 사칭하여 SMS 발송 또는 연락을 취하는 행위
10.	스토킹(stalking) 등 다른 회원을 괴롭히는 행위
11.	재판매의 목적으로 구매하는 행위
12.	회원의 예치금을 제3자와 유상으로 거래하거나 현금으로 전환하는 행위
13.	타인의 결제정보 등을 도용하거나 부정한 행위로 거래를 하는 경우
14.	회원의 예치금을 허용하지 아니한 곳에서 양도하는 경우
15.	기타 불법적이거나 객관적으로 부당한 행위
②	회원은 관계 법령, 본 약관의 규정, 이용안내 및 “서비스”상에 공지한 주의사항, “회사”가 통지하는 사항 등을 준수하여야 하며, 기타 “회사”의 업무에 방해되는 행위를 하여서는 아니 됩니다.
③	회원은 등록정보에 변경사항이 발생할 경우 즉시 갱신하여야 합니다. 회원이 제공한 등록정보 및 갱신한 등록정보가 부정확할 경우, 기타 회원이 본 조 제1항에 명시된 행위를 한 경우에 “회사”는 제23조에 의해 회원의 “서비스” 이용을 제한 또는 중지 할 수 있습니다.
④	회원은 “회사”의 명시적 동의가 없는 한 회원의 “서비스” 이용권한을 타인에게 양도, 증여 또는 이용하게 하거나 이를 담보로 제공할 수 없습니다.
제 19조 (회원의 ID 및 비밀번호에 대한 의무)
①	회원은 ID 및 비밀번호를 철저히 관리하여야 하며, 관리소홀, 부정사용 등에 의하여 발생하는 모든 결과에 대한 책임은 회원 본인이 부담하며, “회사”는 이에 대한 책임을 부담하지 않습니다.
②	회원은 본인의 ID 및 비밀번호를 제3자에게 이용하게 하여서는 아니 되며, 회원 본인의 ID 및 비밀번호를 도난 당하거나 제3자가 사용하고 있음을 인지하는 경우에는 즉시 비밀번호를 변경하여야 하며, 해당 사실을 “회사”에 통지하고 “회사”가 안내하는 바에 따라야 합니다.
제 20조 (회원에 대한 통지)
①	회원에 대한 통지를 하는 경우 “회사”는 회원이 등록한 E-mail 주소 또는 SMS 등으로 할 수 있습니다.
②	“회사”는 불특정 다수 회원에 대한 통지의 경우 “서비스” 게시판 등에 게시함으로써 개별 통지에 갈음할 수 있습니다.
제 21조 (회원의 개인정보보호)
“회사”는 관련법령이 정하는 바에 따라서 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위하여 노력합니다. 회원의 개인정보보호에 관한 사항은 관련법령 및 “회사”가 정하는 통합개인정보처리방침에 정한 바에 따릅니다.
제 22조 (개인정보의 처리 업무 위탁)
“회사”는 수집된 개인정보의 처리 업무를 스스로 수행함을 원칙으로 하나, 필요한 경우 일부 또는 전부를 “회사”가 선정한 제3자에게 위탁할 수 있습니다.
제 5 장 계약해지 및 이용제한
제 23조 (계약해지 및 이용제한)
①	회원이 “서비스” 이용계약을 해지하고자 할 경우에는 회원 본인이 “서비스” 상에서나 또는 “회사”가 정한 별도의 방법을 통해 “회사”에 해지신청을 하여야 합니다.
②	“회사”는 회원이 제18조에 규정한 회원의 의무를 이행하지 않을 경우 사전 통지 없이 “서비스” 이용계약을 해지하거나 또는 “서비스” 이용을 중지할 수 있습니다.
③	“회사”는 회원이 이용계약을 체결하여 ID와 Password를 부여 받은 후에라도 회원의 자격에 따라 “서비스” 이용을 제한할 수 있습니다.
④	본 조 제2항, 제3항의 “회사” 조치에 대하여 회원은 “회사”가 정한 절차에 따라 이의신청을 할 수 있습니다.
⑤	본 조 제4항의 이의가 정당하다고 “회사”가 인정하는 경우, “회사”는 즉시 “서비스”의 이용을 재개합니다.
제 24조 (양도 금지)
회원은 “서비스”의 이용권한, 기타 “서비스” 이용계약상의 지위를 타인에게 양도, 증여할 수 없습니다.
제 6 장 손해배상 등
제 25조 (손해배상)
①	회원이 본 약관의 규정을 위반함으로 인하여 “회사”에 손해가 발생하게 되는 경우, 본 약관을 위반한 회원은 “회사”에 발생하는 모든 손해를 배상하여야 합니다.
②	회원은 “서비스”를 이용함에 있어 행한 불법행위나 본 약관 위반행위로 인하여 “회사”가 당해 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 당해 회원은 자신의 책임과 비용으로 “회사”를 면책 시켜야 하며, 당해 회원은 그로 인하여 “회사”에 발생한 손해를 배상하여야 합니다.
제 26조 (면책사항)
①	“회사”는 천재지변 또는 이에 준하는 불가항력으로 인하여 “회사”의 귀책 사유 없이 “서비스”를 제공할 수 없는 경우에는 그에 관한 책임이 면제됩니다.
②	“회사”는 회원의 귀책사유로 인한 “서비스”의 이용장애에 대하여 책임을 지지 않습니다.
③	“회사”는 불법 또는 부정한 방법으로 “서비스”를 이용하거나 회원의 과실로 인하여 회원 상호간 또는 회원과 제3자 상호간에 발생한 분쟁에 대해서는 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다.
제 27조 (관할법원)
①	“서비스” 이용과 관련하여 “회사”와 회원 사이에 분쟁이 발생한 경우, “회사”와 회원은 분쟁의 해결을 위해 성실히 협의합니다.
②	본 조 제1항의 협의에서도 분쟁이 해결되지 않을 경우 양 당사자는 민사소송법상의 관할법원에 소를 제기할 수 있습니다.
부칙1
[시행일] 본 이용약관은 2024년 10월 1일부터 시행합니다.`)

  const [personalAgreement] = useState(
    `SK텔레콤 리워드 적립 문자 서비스 개인정보 처리방침

1. 총칙
2. 개인정보의 수집, 이용 목적, 항목 및 보유기간
3. 개인정보 수집 방법 및 동의 방법
4. 개인정보 처리 업무의 위탁
5. 수집한 개인정보 제3자 제공
6. 개인정보 보관기간 및 이용기간
7. 개인정보의 파기절차 및 방법
8. 고객의 권리, 의무와 행사 방법
9. 아동의 개인정보보호 및 법정대리인의 권리
10. 개인정보의 자동 수집장치의 설치·운영 및 그 거부에 관한 사항
11. 개인정보 보호를 위한 기술적·관리적 대책
12. 광고성 정보전송
13. 의견수렴 및 불만처리
14. 개인정보보호책임자 및 담당자
15. 개인정보처리방침의 계정과 그 공지


1.	총칙
• 본 「개인정보처리방침」에서 "개인정보"라 함은 살아있는 개인에 관한 정보로서 다음 중 어느 하나에 해당하는 정보를 말합니다.
 가. 성명, 주민등록번호 등에 의하여 개인을 알아볼 수 있는 정보. 
 나. 해당 정보만으로는 특정 개인을 알아볼 수 없어도 다른 정보와 쉽게 결합하여 알아볼 수 있는 정보
 다. 위 가. 또는 나. 의 정보를 가명 처리함으로써 원래의 상태로 복원하기 위한 추가 정보의 사용 · 결합 없이는 특정 개인을 알아볼 수 없는 정보(이하 '가명정보')
• “SK텔레콤 리워드 적립 문자 서비스”(이하 “서비스”라 함)는 개인정보 처리방침을 홈페이지(https://admin.wereward.kr) 첫 화면에 공개함으로써 고객이 언제나 용이하게 볼 수 있도록 조치하고 있습니다.
• “서비스”는 관련 법률 및 지침의 변경, 또는 내부 개인정보 운영방침의 변경에 따라 개인정보 처리방침을 개정할 수 있으며, 개정하는 경우 시행일자 등을 부여하여 개정된 내용을 확인할 수 있도록 하고 있습니다.
• “서비스”의 개인정보 처리방침이 변경되는 경우에는 홈페이지(https://admin.wereward.kr) 등을 통하여 변경 및 시행의 시기, 내용을 고객에게 공지합니다.
2.	개인정보의 수집, 이용 목적, 항목 및 보유기간
• “서비스”는 본질적인 서비스 제공을 위한 ‘필수동의’와 고객 각각의 기호와 필요에 맞는 서비스를 제공하기 위한 ‘선택동의’로 구분하여 개인정보를 수집/이용하고 있습니다. 선택동의에 동의하지 않은 경우에도 본질적인 서비스를 이용할 수 있습니다.
• “서비스”는 고객의 사생활을 현저하게 침해할 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다. 다만, 서비스 제공을 위해 일부 민감정보를 필요 최소한으로 수집, 처리할 필요가 있는 경우 관련 법령의 제한에 따라 고객의 동의 등 필요한 조치를 거쳐 그 개인정보를 수집, 처리할 수 있습니다.
필수동의 항목	수집목적	보유기간
이름, ID(고유번호), Password(비밀번호)	서비스 이용에 따른 본인 식별	회원 탈퇴전까지
휴대전화번호, 이메일 주소	고지사항, 고객불만 확인 결과 안내	회원 탈퇴전까지
회사명, 대표자명, 부서명, 사업자등록번호, 사업자등록증, 업종, 업태, 회사주소	서비스 이용 회사 식별	회원 탈퇴전까지
• “서비스”에서는 법령에 따라 동의 없이 수집할 수 있는 자동생성 정보(로그기록, 과금 정보, 결제기록 등 서비스 계약 이행과정에서 자동적으로 생성되는 정보), 요금정산에 필요한 정보(요금내역, 납부/미납사실, 미납액 등) 등을 필수동의 사항에 기재된 목적 범위 내에서 수집하여 이용할 수 있습니다. 또한 고객이 선택동의에 동의할 경우 해당 목적범위 내에서도 이용할 수 있습니다.
• “서비스”는 법령에 따라 수집 목적과 합리적으로 관련된 범위에서는 고객의 동의 없이 개인정보를 이용할 수 있으며, 이때 '당초 수집 목적과 관련성이 있는지, 수집한 정황 또는 처리 관행에 비추어 볼 때 예측 가능성이 있는지, 고객의 이익을 부당하게 침해하는지, 가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지'를 종합적으로 고려합니다.
3. 개인정보 수집 방법 및 동의 방법 
• “서비스”는 고객의 ‘개인정보 수집 및 이용’에 대한 동의 절차를 두고, 고객이 이에 대해 '동의한다' 또는 '동의하지 않는다' 를 체크하거나 버튼을 클릭할 수 있는 등의 절차를 마련하고 있습니다. '동의한다' 항목에 체크를 하거나 버튼을 클릭하면 개인정보 수집 및 이용에 대해 동의한 것으로 봅니다.
• “고객”은 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부할 경우 받는 별도의 불이익은 없습니다. 단, 필수동의 사항에 동의를 거부할 경우, 서비스 이용이 불가능하거나, 서비스 이용 목적에 따른 서비스 제공에 제한이 따르게 됩니다.
4. 개인정보 처리 업무의 위탁
• “서비스” 업무위탁계약서 등을 통하여 위탁업무 수행목적 외 개인정보의 처리 금지에 관한 사항, 개인정보의 기술적, 관리적 보호조치에 관한 사항, 위탁업무의 목적 및 범위, 재위탁 제한에 관한 사항, 개인정보에 대한 접근 제한 등 안전성 확보 조치에 관한 사항, 위탁업무와 관련하여 보유하고 있는 개인정보의 관리현황 점검 등 감독에 관한 사항, 개인정보 사고시의 책임부담, 처리 종료 후의 개인정보의 반환 또는 파기 의무 등을 규정하고, 이를 준수하도록 관리하고 있습니다.
• “서비스”는 보다 나은 서비스 제공, 고객편의 제공 등 원활한 업무 수행을 위하여 다음과 같이 개인정보 처리 업무를 외부 전문업체에 위탁하여 운영하고 있습니다. 수탁업체 리스트는 해당 서비스 변경 및 계약기간에 따라 변경될 수 있으며 변경 시 각 서비스에서 정한 방식을 통해 공지하고 특별히 정하지 않은 경우 공지사항을 통해 공지합니다.
위탁업체명	위탁업무
SK플래닛 주식회사	사이트 고객관리
㈜위픽코퍼레이션	시스템 운영

5. 수집한 개인정보의 제3자 제공
• “서비스”는 고객의 개인정보를 고객으로부터 동의 받거나 법령에 의해 허용된 범위 내에서 사용하며, 동 범위를 넘어 이용하거나 제3자에게 제공하지 않습니다. 단, “서비스”는 법령에 따라 수집 목적과 합리적으로 관련된 범위에서는 고객의 동의 없이 개인정보를 제공할 수 있으며, 이때 '당초 수집 목적과 관련성이 있는지, 수집한 정황 또는 처리 관행에 비추어 볼 때 예측 가능성이 있는지, 고객의 이익을 부당하게 침해하는지, 가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지'를 종합적으로 고려합니다.
특히, 다음의 경우에는 위와 같은 범위 내에서 주의를 기울여 개인정보를 제공할 수 있습니다.
가. 제휴관계
보다 나은 서비스 제공을 위하여 고객의 개인정보를 제휴사에게 제공하거나 또는 제휴사와 공유할 수 있습니다. 개인정보를 제공하거나 공유할 경우에는 사전에 고객에게 제휴사가 누구인지, 제공 또는 공유되는 개인정보항목이 무엇인지, 왜 그러한 개인정보가 제공되거나 공유되어야 하는지, 그리고 언제까지 어떻게 보호ㆍ관리되는지에 대해 개별적으로 서면 또는 전자우편 등을 통해 고지하여 동의를 구하는 절차를 거치게 되며, 고객이 동의하지 않는 경우에는 제휴사에게 제공하거나 제휴사와 공유하지 않습니다. 제휴관계에 변화가 있거나 제휴관계가 종결될 때도 같은 절차에 의하여 고지하거나 동의를 구합니다.
나. 매각 · 인수합병 등
영업의 전부 또는 일부를 양도하거나, 합병ㆍ상속 등으로 서비스제공자의 권리ㆍ의무를 이전 승계하는 경우 개인정보보호 관련 고객의 권리를 보장하기 위하여 그 사실을 고객에게 통지합니다.
다. 법령에 의해 필요하거나 허용되는 경우
• 요금정산을 위하여 필요한 경우
• 통신비밀보호법, 국세기본법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보 보호법, 금융실명거래 및 비밀보장에 관한 법률, 신용정보의 이용 및 보호에 관한 법률, 전기통신기본법, 전기통신사업법, 지방세법, 소비자기본법, 한국은행법, 형사소송법 등 다른 법률에 특별한 규정이 있는 경우
※ 단, '법률에 특별한 규정이 있는 경우'로 행정목적이나 수사목적으로 행정관청 또는 수사기관이 요구해 온 경우라도 무조건 고객의 개인정보를 제공하지 않으며, 영장 또는 기관장의 직인이 날인된 서면에 의한 경우 등 법률에서 규정한 적법한 절차에 따라 제공합니다.
6. 개인정보의 보관기간 및 이용기간
• 회사는 다른 내용으로 동의를 받거나 법령상의 근거가 있지 않는 한 원칙적으로 고객의 서비스 가입일로부터 고객에게 서비스를 제공하는 기간 동안에 한하여 고객의 개인정보를 보유 및 이용하게 됩니다. 고객이 회원 탈퇴를 요청하거나 개인정보의 수집 및 이용에 대한 동의를 철회하는 경우, 수집/이용목적을 달성하거나 보유/이용기간이 종료한 경우, 사업폐지 등의 파기사유 발생시 당해 개인정보를 지체 없이 파기합니다. 단, 이용요금의 정산, 소송이나 분쟁 등 기타 필요한 경우를 대비하여 보유하여야 할 필요가 있을 경우 개인정보는 해당 목적이 달성될 때까지 일정기간 보유합니다.
• 또한 상법, 국세기본법, 통신비밀보호법, 전자상거래 등에서 소비자보호에 관한 법률, 신용정보의 이용 및 보호에 관한 법률 등 관계법령에 따라 보존할 필요가 있는 경우 회사는 관계법령에서 정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 각 법령에 따른 보관근거, 보관하는 항목, 보관기간의 예를 들면 다음과 같습니다.
가. 전기통신사업자가 통신사실확인자료 제공 시 필요한 성명, 주민등록번호, 이동전화번호: 12개월 (통신비밀보호법)
나. 전기통신사업자에게 보관의무가 있는 가입자의 전기통신 일시, 전기통신 개시ㆍ종료시간, 통신번호 등 상대방의 가입자번호, 사용도수, 정보통신망에 접속된 정보통신기기의 위치자료: 12개월 (통신비밀보호법)
다. 성명, 주민등록번호, (해지)이동전화번호, 청구서 배달 주소, 요금, 계약서 등 거래내역 관련 정보: 5년(단, 해지 후 6개월이 지난 고객의 개인정보는 별도의 분리된 저장공간에 보관) (국세기본법, 법인세법, 부가가치세법)
라. 상업장부와 영업에 관한 중요서류 및 전표: 중요서류는 10년 / 전표(상법)는 5년
마. 통신사실확인자료 제공 시 필요한 로그기록자료, IP주소 등 : 3개월(통신비밀보호법)
바. 표시/광고에 관한 기록 : 6개월(전자상거래 등에서의 소비자보호에 관한 법률)
사. 계약 또는 청약철회 등에 관한 기록 : 5년(전자상거래 등에서의 소비자보호에 관한 법률)
아. 대금결제 및 재화 등의 공급에 관한 기록 : 5년(전자상거래 등에서의 소비자보호에 관한 법률)
자. 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년(전자상거래 등에서의 소비자보호에 관한 법률) 차. 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년(신용정보의 이용 및 보호에 관한 법률)
7. 개인정보 파기절차 및 방법
• “서비스”는 수집한 개인정보의 이용목적이 달성된 후에는 보관기간 및 이용기간에 따라 해당 정보를 지체 없이 복구 불가능하도록 파기합니다. 파기절차, 방법, 시점은 다음과 같습니다.
가. 파기절차 및 시점
고객이 “서비스” 가입 등을 위해 기재한 개인정보는 “서비스” 해지 등 이용목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보호 방침에 의해 삭제되거나 파기합니다. 일반적으로 채권-채무 관계가 없는 경우, “서비스” 가입 시 수집되어 전자적 파일형태로 관리하는 개인정보는 회원 탈퇴 시점에 바로 삭제 됩니다. 단, 고객에게 미리 고지하고 개별 동의를 받은 경우는 동의한 내용에 따른 보유기간 동안 보유 후 삭제되며, 관련 법령의 규정에 의하여 개인정보를 보유해야 할 필요가 있는 경우에는 해당 법령에서 정한 기간 동안 보유한 후 해당 기간이 지나면 회원의 모든 데이터를 삭제합니다.
나.	파기방법
가입신청서 등 서면양식에 기재하거나, 종이에 출력된 개인정보는 분쇄기로 분쇄 또는 소각하거나 화학약품 처리를 하여 용해하여 파기하고, 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
8. 고객의 권리, 의무와 행사 방법
• 고객은 언제든지 본인에 관한 개인정보 현황, “서비스”가 개인정보를 이용하거나 제3자에게 제공한 현황, 개인정보의 수집·이용·제공 등의 동의 현황을 열람하거나 제공받을 수 있습니다. “서비스”는 고객이 개인정보에 대한 열람ㆍ제공 또는 정정을 요구하는 경우에는 고객의 요구에 성실하게 대응하고, 해당 개인정보에 오류가 있거나 보존기간을 경과한 것이 판명되는 등 정정ㆍ삭제를 할 필요가 있다고 인정되는 경우에는 지체 없이 정정ㆍ삭제를 합니다.
• 고객은 개인정보 수집ㆍ이용 또는 제공에 대한 동의철회(가입ㆍ해지)를 요구할 수 있고 “서비스”는 지체 없이 필요한 조치를 취합니다. 고객은 언제든지 개인정보 수집·이용·제공 등의 동의를 철회할 수 있습니다. 다만, 회원가입 및 본질적 서비스 제공에 필요한 개인정보 등에 대한 동의를 철회하는 경우 회원탈퇴 및 서비스 해지가 불가피하여, 고객에게 제공되는 서비스를 받지 못하게 될 수 있습니다.
9. 아동의 개인정보보호 및 법정대리인의 권리
• “서비스”는 B2B서비스로서 만 14세 미만의 개인정보를 수집하지 않습니다.
10. 개인정보의 자동 수집장치의 설치·운영 및 그 거부에 관한 사항
• “서비스”에서 제공하는 인터넷서비스를 통하여 고객님의 정보를 저장하고 수시로 찾아내는 쿠키(cookie)를 설치/운용할 경우도 있습니다. 쿠키란 웹 서버가 웹 브라우저에 보내어 저장했다가 서버의 부가적인 요청이 있을 때 다시 서버로 보내주는 문자열 정보를 말합니다. 고객님께서 “서비스” 홈페이지(https://admin.wereward.kr)에 접속을 하면 고객님의 브라우저에 있는 쿠키의 내용을 읽고, 추가정보를 찾아 접속에 따른 성명 등의 추가 입력 없이 서비스를 제공할 수 있습니다.
• “서비스”가 쿠키를 통해 수집하는 정보는 회원의 ID에 한하며, 그 외의 다른 정보는 수집하지 않습니다. 회사가 쿠키(cookie)를 통해 수집한 회원의 ID는 다음의 목적을 위해 사용될 수 있습니다.
가. 개인의 관심 분야에 따라 차별화된 정보를 제공
나. 회원과 비회원의 접속 빈도 또는 머문 시간 등을 분석하여 이용자의 취향과 관심분야를 파악하여 마케팅에 활용
다. 관심 있게 둘러본 내용들에 대한 자취를 추적하여 다음 번 접속 때 개인 맞춤 서비스를 제공
라. 유료서비스 이용 시 이용기간 안내
마. 회원들의 습관을 분석하여 서비스 개편 등의 척도로 활용
• 고객님께서는 쿠키 설치에 대한 선택권을 가지고 있습니다. 웹 브라우저 상단의 “도구 > 인터넷옵션 > 개인정보 > 고급” 에서 모든 쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나, 아니면 모든 쿠키를 거부할 수 있습니다. 단, 고객님께서 쿠키 설치를 거부하였을 경우 서비스 이용에 불편이 있거나, 서비스 제공에 어려움이 있을 수 있습니다. 쿠키는 브라우저의 종료 시나 로그 아웃 시 만료됩니다.
11. 개인정보 보호를 위한 기술적·관리적 대책
• “서비스”에서는 고객님의 개인정보를 보호하기 위해 기술적 대책과 관리적 대책을 마련하고 있으며, 이를 적용하고 있습니다.
가. 기술적 대책

o	고객님의 개인정보는 비밀번호에 의해 보호되며 파일 및 전송데이터를 암호화하거나 파일 잠금 기능(Lock)을 사용하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.
o	“서비스”는 백신프로그램을 이용하여 컴퓨터 바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신프로그램은 주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다.
o	“서비스”는 암호알고리즘을 이용하여 네트워크 상의 개인정보를 안전하게 전송할 수 있는 보안장치(SSL 또는 SET)를 채택하고 있습니다.
o	해킹 등 외부침입에 대비하여 각 서버마다 침입차단시스템 및 취약점 분석시스템 등을 이용하여 보안에 만전을 기하고 있습니다.
나. 관리적 대책
o	“서비스”는 고객님의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있으며, 개인정보 취급자의 개인정보 사고에 대한 책임을 명확히 하고 있습니다.
o	“서비스”는 컴퓨터를 이용하여 고객의 개인정보를 처리하는 경우 개인정보에 대한 접근권한을 가진 담당자를 지정하여 식별부호(ID) 및 비밀번호를 부여하고, 해당 비밀번호를 정기적으로 갱신하고 있습니다.
o	개인정보를 처리하는 직원을 대상으로 개인정보보호 의무 에 관해 정기적인 사내 교육을 실시하고 있습니다.
o	신규직원 채용 시 정보보호서약서 또는 개인정보보호서약서에 서명함으로 직원에 의한 정보유출을 사전에 방지하고 개인정보 처리방침에 대한 이행사항 및 직원의 준수여부를 감사하기 위한 내부절차를 마련하여 지속적으로 시행하고 있습니다.
o	직원 퇴직 시 비밀유지서약서에 서명함으로 고객의 개인정보를 처리하였던 자가 직무상 알게 된 개인정보를 훼손ㆍ침해 또는 누설하지 않도록 하고 있습니다.
o	개인정보 처리자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며, 입사 및 퇴사 후 개인정보 침해사고에 대한 책임을 명확하게 규정하고 있습니다.
o	전산실 및 자료 보관실 등을 보호구역으로 설정하여 출입을 통제하고 있습니다.
o	그 외 내부 관리자의 실수나 기술관리 상의 사고로 인해 개인정보의 상실, 유출, 위조, 변조, 훼손이 유발될 경우 “서비스”는 즉각 고객님께 사실을 알리고 적절한 대책과 보상을 강구할 것입니다.
12. 광고성 정보 전송
• “서비스”는 고객의 사전 동의 없이 영리목적의 광고성 정보를 전송하지 않습니다.
• “서비스”는 신상품이나 이벤트 정보안내 등 고객 지향적인 마케팅을 수행하기 위하여 광고성 정보를 전자매체를 통해 전송하는 경우에는 광고성 정보 전송에 대한 고객의 사전 동의를 득하고 전자매체의 제목란 및 본문란에 아래와 같이 고객이 광고성 정보임을 쉽게 알아 볼 수 있도록 조치합니다.
• 전자매체의 제목란: '(광고)' 문구를 제목란의 처음에 빈칸 없이 한글로 표시하고 이어서 전자매체 본문란의 주요 내용을 표시합니다. 단, 제목란 등에 광고임을 표시하기 어려운 전자매체를 통해 영리목적의 광고성 정보를 전송하는 경우에도 전송자의 명칭을 표기하는 등 필요한 조치를 취합니다.
• “서비스”에서는 고객의 광고성 정보 수신동의시, 수신거부시, 수신동의 철회시 해당 사실을 고객에게 해당 사실 발생일로부터 14일내에 고지합니다. 또한 고객이 광고성 정보 수신동의를 한 날로부터 매 2년 마다 고객의 광고성 정보 수신동의 사실을 고객에게 확인합니다.
13. 의견 수렴 및 불만 처리
• 회사는 고객의 의견을 매우 소중하게 생각합니다. 고객께서 문의사항이 있을 경우 고객센터 등에 연락을 하여 문의하시면 신속 · 정확한 답변을 드리겠습니다. 고객센터 연락처는 다음과 같습니다.
• 사이버상담: 홈페이지(https://admin.wereward.kr)에 접속하신 후 참여 완료한 캠페인 선택하여 해당 캠페인 하단 ‘지급 문의’ 메뉴를 통해 질문을 하실 수 있습니다.
14. 개인정보보호 책임자 및 담당자
• 회사는 고객님이 안전하게 서비스를 이용할 수 있도록 개인정보 보호에 최선을 다하고 있습니다. 개인정보를 보호하는데 있어 고객님께 고지한 사항들에 반하는 사고가 발생할 시에 개인정보보호 책임자가 모든 책임을 집니다. 고객님의 개인정보를 처리하는 책임자 및 담당자는 다음과 같으며 개인정보 관련 문의사항에 신속하고 성실하게 답변해드리고 있습니다.
가. 개인정보보호책임자: 박우종 팀장
나. 개인정보보호담당자: 이재웅 매니저
다. 소속부서: SK텔레콤 메시징사업팀
라. 전화번호: 02-6100-5812
마. 이메일: bizchat@sktelecom.com
15. 개인정보처리방침의 계정과 그 공지
• 현 개인정보처리방침이 추가 및 삭제, 수정이 있을 시에는 시행 7일 전에 홈페이지를 통해 사전 
공지하며, 사전 공지가 곤란한 경우 지체 없이 공지할 수 있습니다. 이 정책은 공지한 날로부터 시행됩니다. 
- 공고일자: 2024년 8월 1일
- 시행일자: 2024년 9월 1일


    `)

  const handleChange = (e: CheckboxChangeEvent) => {
    const { id, checked } = e.target;
    if (id) {
      onAgreementChange(id, checked);
    }
  };

  return (
    <S.Container>
      <S.Title>약관 동의</S.Title>
      <S.AgreementSection>
        <S.CheckboxWrapper>
          <Checkbox id="agreement1" checked={agreements.agreement1} onChange={handleChange}>
            [필수] 서비스 이용약관 동의
          </Checkbox>
        </S.CheckboxWrapper>
        <S.TextareaWrapper>
          <textarea readOnly value={serviceAgreement} />
        </S.TextareaWrapper>
      </S.AgreementSection>
      <S.AgreementSection>
        <S.CheckboxWrapper>
          <Checkbox id="agreement2" checked={agreements.agreement2} onChange={handleChange}>
            [필수] 개인정보 수집 및 이용 동의
          </Checkbox>
        </S.CheckboxWrapper>
        <S.TextareaWrapper>
          <textarea readOnly value={personalAgreement} />
        </S.TextareaWrapper>
      </S.AgreementSection>
      {/* <S.AgreementSection>
        <S.CheckboxWrapper>
          <Checkbox id="agreement3" checked={agreements.agreement3} onChange={handleChange}>
            [필수] 광고게재 신청 기준 동의
          </Checkbox>
        </S.CheckboxWrapper>
        <S.TextareaWrapper>
          <textarea readOnly />
        </S.TextareaWrapper>
      </S.AgreementSection> */}
    </S.Container>
  );
};

export default ConsentAgreement;
